import React from 'react';

export function SummaryBarPlaceholder() {
  return (
    <React.Fragment>
      <div
        className="summary-bar-placeholder"
        style={{
        paddingTop: '8px',
        backgroundColor: '#f3f2f1',
        height: '100%',
        width: '100%',
        borderBottom: 'solid 1px #e1dfdd',
      }}
      >
        <div style={{
          display: 'flex',
        }}
        >
          <div style={{
            margin: '0px 8px 8px 8px',
            backgroundColor: '#e1dfdd',
            height: '28px',
            width: '100%',
          }}
          />
          <div style={{
            width: '1px',
            right: '0',
            height: '44px',
            marginTop: '-8px',
            position: 'absolute',
            backgroundColor: '#e1dfdd',
          }}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
